import { Component, OnInit,OnChanges, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { FileUploadService } from 'src/app/services/file-upload.service';

@Component({
  selector: 'app-apply-label',
  templateUrl: './apply-label.component.html',
  styleUrls: ['./apply-label.component.css']
})
export class ApplyLabelComponent implements OnInit,OnChanges {

  api_error: any;
  api_success: string;
  acc_status;
  statusTo: string;
  disableConfirmbtn = false;
  changeStatus;
  loading = false;
  providerLabels: any = [];
  res;
  showApply = false;
  labelsforRemove: any = [];
  labelMap = {};
  labelNames: any = [];
  label: any;
  accData;
  checkinsByLabel: any = [];
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any,private router: Router, private route: ActivatedRoute,private activatedRoute: ActivatedRoute, private accountService: AccountService,private fileuploadService: FileUploadService,) { }

  ngOnInit() {
    //   console.log(this.data)
    this.accData = this.data;
    this.getLabel();
  }
  ngOnChanges(){
    this.dialogRef.close('reload');
    this.getLabel();  
  }
  public closeDialog() {
    this.dialogRef.close('reload');
  }
  getLabel() {
    this.loading = true;
    this.providerLabels = [];
    this.accountService.getLabels().subscribe((data: any) => {
        this.providerLabels = data.filter(label => label.status === 'ENABLED');
        // console.log(this.data.multiSelection)
        if (!this.data.multiSelection) {
            this.labelselection();
        } else {
            this.multipleLabelselection();
        }
        this.loading = false;
    });
}
    labelselection() {
        const values = [];
        if (this.accData.label && Object.keys(this.accData.label).length > 0) {
            Object.keys(this.accData.label).forEach(key => {
                values.push(key);
            });
            for (let i = 0; i < this.providerLabels.length; i++) {
                for (let k = 0; k < values.length; k++) {
                    if (this.providerLabels[i].label === values[k]) {
                        this.providerLabels[i].selected = true;
                    }
                }
            }
        }
    }
    addLabeltoAppt(label, e) {
      this.showApply = false;
      let labelArr = this.providerLabels.filter(lab => lab.label === label);
      if (this.labelMap[label]) {
          delete this.labelMap[label];
      }
      if (this.labelsforRemove.indexOf(label) !== -1) {
          this.labelsforRemove.splice(this.labelsforRemove.indexOf(label), 1);
      }
      if (e.target.checked) {
          if (labelArr[0] && labelArr[0].selected) {
          } else {
              this.labelMap[label] = true;
              this.labelNames = labelArr.label
          }
      } else {
          if (labelArr[0] && labelArr[0].selected) {
              this.labelsforRemove.push(label);
          }
      }
      if (Object.keys(this.labelMap).length > 0 || this.labelsforRemove.length > 0) {
          this.showApply = true;
      }
  }
  multipleLabelselection() {
    let values = [];
    this.checkinsByLabel = [];
    for (let i = 0; i < this.accData.length; i++) {
        if (this.accData[i].label) {
            Object.keys(this.accData[i].label).forEach(key => {
                values.push(key);
                if (!this.checkinsByLabel[key]) {
                    this.checkinsByLabel[key] = [];
                }
                this.checkinsByLabel[key].push(this.accData[i].id);
            });
        }
    }
    for (let i = 0; i < this.providerLabels.length; i++) {
        for (let k = 0; k < values.length; k++) {
            const filteredArr = values.filter(value => value === this.providerLabels[i].label);
            if (filteredArr.length === this.accData.length) {
                this.providerLabels[i].selected = true;
            }
        }
    }
}
applyLabel() {
    if (Object.keys(this.labelMap).length > 0) {
        this.addLabel();
    }
    if (this.labelsforRemove.length > 0) {
        this.deleteLabel();
    }
}
gotoLabel() {
    this.dialogRef.close({ data: 'data' })
}
deleteLabel() {
    const ids = [];
    ids.push(this.data.id);
    const postData = {
        'accId': ids,
        'labelNames': this.labelsforRemove
    };
    this.accountService.deleteLabels(postData).subscribe(data => {
        this.api_success = 'Label Removed Successfully';
        setTimeout(() => {
            this.dialogRef.close('reload');
          }, 500);
         },
        error => {
            this.disableConfirmbtn = false;
            this.api_error = error.error;
        });  
}

getDisplayname(label) {
    for (let i = 0; i < this.providerLabels.length; i++) {
        if (this.providerLabels[i].label === label) {
            return this.providerLabels[i].displayName;
        }
    }
}
addLabel() {
    const ids = [];
    ids.push(this.data.id);
    const postData = {
        'labels': this.labelMap,
        'accId': ids,
        'labelNames': this.labelNames
    };
    this.accountService.ApplyLabels(postData).subscribe(data => {
        this.api_success = 'Label Applied Successfully';
          setTimeout(() => {
            this.dialogRef.close('reload');
            }, 500);
         },
        error => {
            this.disableConfirmbtn = false;
            this.api_error = error.error;
        });
}
}
